<template>
  <DModal :isBgOverlay="true" :showClose="false" :placeInTop="true">
    <div class="do-modal do-modal__edit-user-norm" slot="insertComponent">
      <div class="do-modal__header">
        <h2>Rediger {{ user.name }}</h2>
        <div class="icon__bg-circle doc-modal__close" @click="close">
          <span class="icon-cross2"></span>
        </div>
      </div>

      <div class="do-modal__body">
        <div class="do-spinner__container" v-if="isLoading">
          <div class="do-spinner do-spinner--large"></div>
        </div>
        <AssignHoursNormList
          :isNetto="false"
          :schoolYear="schoolYear"
          :theEditUserNorm="theEditUserNorm"
          @updated="setItemsToSave"
          @changedSum="setNettoTime">
        </AssignHoursNormList>
      </div>
      <div class="do-modal__footer">
        <button class="do-bttn" @click="close">{{ $t('vue2.common.cancel') }}</button>
        <button
          class="do-bttn do-bttn--submit"
          :class="{ 'do-bttn--submit--loading': isUpdating }"
          @click="onUpdate"
        >
          {{ $t('vue2.common.update') }}
        </button>
      </div>
    </div>
  </DModal>
</template>
<script>
import DModal from '../common/DModal.vue'
import docendo from '../../docendo'
import AssignHoursNormList from './AssignHoursNormList.vue'

export default {
  components: {AssignHoursNormList, DModal},
  props: {
    user: {
      type: Object,
      default: null
    },
    schoolId: {
      default: null
    },
    schoolYear: {
      default: null
    }
  },
  data () {
    return {
      isUpdating: false,
      theEditUserNorm: null,
      userAgreements: null,
      isLoading: false,
      itemsToSave: [],
      nettoTime: null
    }
  },
  methods: {
    setItemsToSave (arr) {
      this.itemsToSave = arr
    },
    setNettoTime (val) {
      // kommer fra AssignHoursNormList (@changedSum)
      this.nettoTime = val
    },
    validateNumber (item) {
      const itemsNotToValidate = [
        'hidden_ansættelsesgrad',
        'Periode',
        'hidden_periode_start',
        'hidden_periode_end',
        'Ansættelsesgrad'
      ]
      if (itemsNotToValidate.indexOf(item.title) > -1) {
        return item.value
      }
      const val = item.hours * 1
      return val.toFixed(2)
    },
    // Hvis nettoTime ikke er sat via @changedSum, forsøg at finde den i itemsToSave
    findArbejdstidFromItems () {
      // kig efter de mulige feltnavne der kan repræsentere arbejdstid i perioden
      const keys = ['Arbejdstid i perioden', 'Nettotid', 'Bruttotid', 'Arbejdstid']
      for (let i = 0; i < this.itemsToSave.length; i++) {
        const it = this.itemsToSave[i]
        if (!it || !it.title) continue
        if (keys.indexOf(it.title) > -1) {
          // it.value kan være string/number
          return (it.value * 1).toFixed(2)
        }
        if (it.id === 'working_hours') {
          return (it.hours * 1).toFixed(2)
        }
      }
      return null
    },
    onUpdate () {
      if (!this.schoolYear || !this.schoolYear.name) {
        // brug gerne dit eget toast-system her
        console.error('Skoleår er ikke indlæst endnu')
        return
      }
      if (!this.user || !this.user.id) {
        console.error('Bruger mangler')
        return
      }

      this.isUpdating = true

      // map norm-elementer
      const mapped = this.itemsToSave.map(item => {
        return {
          title: item.title,
          value: this.validateNumber(item)
        }
      })

      // Arbejdstid (netto) tilføjes altid
      let arbejdstid = this.nettoTime
      if (!arbejdstid) {
        arbejdstid = this.findArbejdstidFromItems()
      }
      if (arbejdstid) {
        mapped.push({
          title: 'Arbejdstid',
          value: arbejdstid
        })
      }

      const payload = {
        norm: mapped
      }

      // assigned_total_hours følger Arbejdstid hvis vi har den
      if (arbejdstid) {
        payload.assigned_total_hours = arbejdstid
      }
      /*
      // gem også note hvis du ønsker det (her bruger vi userAgreements hvis sat)
      if (this.userAgreements) {
        payload.agreements = this.userAgreements
      }
       */

      const dataToSave = [
        {
          user_id: this.user.id,
          data: payload
        }
      ]

      docendo.bulkSchoolUserYearUpdate(
        this.schoolId,
        this.schoolYear.name,
        dataToSave,
        success => {
          docendo.schoolUsers(this.schoolId, [this.user.id], success => {
            const updatedUser = success[0]
            this.$store.commit('updateSchoolUser', updatedUser)
            this.$emit('updated')
            // this.$emit('updated', theEditUserNorm)
          }, failure => {
            console.log('failure')
          })
        },
        failure => {
          this.isUpdating = false
          console.error('Noget gik galt ved opdatering')
        }
      )
    },
    close () {
      this.$emit('close')
    },
    readUserNorm () {
      this.isLoading = true
      docendo.schoolUserYearRead(this.schoolId, this.user.id, this.schoolYear.name, success => {
        this.theEditUserNorm = success.norm ? success.norm : []
        this.userAgreements = success.agreements ? success.agreements : ''
        this.isLoading = false
      }, failure => {
        console.log('failed!')
      })
    }
  },
  mounted () {
    this.readUserNorm()
  }
}
</script>

<style scoped>
.do-modal__footer {
  gap: 1rem;
}

.do-spinner__container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f7f9fc;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.do-modal__body {
  position: relative;
  padding: 1rem;
}

.do-modal__edit-user-norm {
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// AssignHoursNormEditIUserModal.vue?da7e70ee